/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseCourseidLanguages200,
  GetApiV1CourseCourseidLanguages400,
  GetApiV1CourseCourseidLanguages401,
  GetApiV1CourseCourseidLanguages404,
  GetApiV1CourseCourseidLanguages500,
  GetApiV1CourseCourseidLanguagesPathParams,
  GetApiV1CourseCourseidLanguagesQueryParams,
  GetApiV1CourseCourseidLanguagesQueryResponse,
} from "../../types/courseLangsController/GetApiV1CourseCourseidLanguages.ts";
import { courseLangListItemViewModelPaginatedResponseSchema } from "../courseLangListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1CourseCourseidLanguagesPathParamsSchema = z.object({
  courseId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CourseCourseidLanguagesPathParams>;

export const getApiV1CourseCourseidLanguagesQueryParamsSchema = z.object({
  Search: z.optional(
    z
      .string()
      .describe(
        "Texto livre aplicado ao idioma, ao nome oficial e ao nome comercial. Máximo de 200 caracteres. Opcional.",
      ),
  ),
  PageNumber: z.coerce
    .number()
    .int()
    .default(1)
    .describe("Página da listagem. Mínimo 1."),
  PageSize: z.coerce
    .number()
    .int()
    .default(30)
    .describe("Quantidade de itens por página. Entre 1 e 100."),
}) as unknown as ToZod<GetApiV1CourseCourseidLanguagesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseCourseidLanguages200Schema = z.lazy(
  () => courseLangListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1CourseCourseidLanguages200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseCourseidLanguages400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguages400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseCourseidLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseCourseidLanguages404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguages404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseCourseidLanguages500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguages500>;

export const getApiV1CourseCourseidLanguagesQueryResponseSchema = z.lazy(
  () => getApiV1CourseCourseidLanguages200Schema,
) as unknown as ToZod<GetApiV1CourseCourseidLanguagesQueryResponse>;
